export enum DataKeys {
  CHECKBOX = 'checkbox',
  ID = 'id',
  NAME = 'name',
  ROLES = 'roles',
  ACCOUNT_POSITION = 'account-position',
  ACCOUNT_TYPE = 'account-type',
  EMAIL = 'email',
  PHONE = 'phone',
  STATUS = 'status',
  PROJECTS = 'projects',
}
